import { render } from "./DeliveryConfirm.vue?vue&type=template&id=3b5bfc8e&scoped=true"
import script from "./DeliveryConfirm.vue?vue&type=script&lang=js"
export * from "./DeliveryConfirm.vue?vue&type=script&lang=js"

import "./DeliveryConfirm.vue?vue&type=style&index=0&id=3b5bfc8e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5bfc8e"]])

export default __exports__